import(/* webpackMode: "eager", webpackExports: ["Loading"] */ "/builds/jetspeak/jetclass-web/govoriru/components/Loading/Loading.tsx");
